<template>
  <div>
    <div class="modal-backdrop fade show"></div>

    <div
      class="modal fade show modal-dialog-scrollable"
      >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ isAdd ? 'Новый этап' : 'Редактирование' }}.
            </h5>

            <button type="button" class="close" @click="$emit('cancel')">
              <span aria-hidden="true">×</span>
            </button>
          </div>

          <div class="modal-body">
            <form>
              <div class="form-group">
                <label>Название</label>
                <input type="text" class="form-control" v-model="title"/>
              </div>

              <div class="form-group">
                <label>Дата начала</label>
                <input type="text" class="form-control" v-model="dateFrom"/>
              </div>

              <div class="form-group">
                <label>Дата окончания</label>
                <input type="text" class="form-control" v-model="dateTo"/>
              </div>

              <div class="mb-2">
                <div class="float-right text-primary">
                  Выбрано <span class="font-weight-bold">{{goals.length}}</span>
                </div>
                Стратеги
              </div>

              <div class="border-top">
                <div
                  v-for="strategy in strategies"
                  :key="strategy.id"
                  :class="`cursor-pointer py-2 px-3 border-left border-right border-bottom ${goals.includes(strategy.id) ? 'bg-primary' : ''}`"
                  @click="toggleStrategy(strategy.id)"
                >
                  {{strategy.title}}
                </div>
              </div>
            </form>
          </div>

          <div class="modal-footer pb-5">
            <Flash v-if="error" :message="error" type="danger" v-on:close="error = ''"/>

            <button
              type="button"
              class="btn btn-primary"
              @click="submitForm"
              :disabled="sending">
              {{ isAdd ? 'Добавить' : 'Обновить' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatDate from '../../../utils/formatDate';
import Flash from '../../common/Flash';

export default {
  name: 'ClientStrategyForm',

  components: {Flash},

  props: ['strategies', 'stages', 'stage', 'lastStageDate', 'unfinishedGoals'],

  data() {
    return {
      error: '',
      title: '',
      dateFrom: formatDate(new Date(), 'y-m-d'),
      dateTo: formatDate(new Date(), 'y-m-d'),
      goals: [],
      sending: false,
    };
  },

  created() {
    if (typeof this.stage !== 'undefined') {
      this.title = this.stage.title;
      this.goals = this.stage.goals.map(i => i.strategy);

      if (this.stage.dateFrom !== '') {
        this.dateFrom = formatDate(this.stage.dateFrom, 'y-m-d');
      }

      if (this.stage.dateTo !== '') {
        this.dateTo = formatDate(this.stage.dateTo, 'y-m-d');
      }
    } else {
      let now = new Date();

      if (this.lastStageDate instanceof Date) {
        now = new Date(this.lastStageDate);
      }

      this.title = `Этап ${(this.stages.length + 1)}`;
      this.dateFrom = formatDate(now, 'y-m-d');

      now.setMonth(now.getMonth() + 3);

      this.dateTo = formatDate(now, 'y-m-d');
      this.goals = this.unfinishedGoals.map(i => i);
    }
  },

  computed: {
    isAdd() {
      return typeof this.stage === 'undefined';
    },
  },

  methods: {
    toggleStrategy(id) {
      if (this.goals.includes(id)) {
        this.goals.splice(this.goals.indexOf(id), 1);
      } else {
        this.goals.push(id);
      }
    },

    submitForm() {
      if (this.sending) {
        return;
      }

      this.error = '';

      if (typeof this.title !== 'string' || this.title.trim() === '') {
        this.error = 'Нужно заполнить название этапа';
      }

      const goals = [];

      for (const goal of this.goals) {
        goals.push({
          strategy: goal,
        });
      }

      if (goals.length === 0) {
        this.error = 'Нужно выбрать хотябы одну стратегию';
      }

      if (typeof this.dateFrom !== 'string' || this.dateFrom.trim() === '') {
        this.error = 'Дата начала не указана';
      }

      if (/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(this.dateFrom) !== true) {
        this.error = 'Дата начала указана неправильно';
      }

      if (typeof this.dateTo !== 'string' || this.dateTo.trim() === '') {
        this.error = 'Дата окончания не указана';
      }

      if (/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(this.dateTo) !== true) {
        this.error = 'Дата окончания указана неправильно';
      }

      if (this.error !== '') {
        return;
      }

      const data = {
        title: this.title,
        dateFrom: new Date(this.dateFrom),
        dateTo: new Date(this.dateTo),
        goals,
      };

      if (typeof this.stage !== 'undefined') {
        data.id = this.stage.id;
      }

      this.sending = true;

      this.$emit('submit', data);
    },
  },
};
</script>
